import styled from 'styled-components';
import { customTextColor } from '../../../constants/CommonStyles';

export const L14M = styled.p`
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;

  ${customTextColor}
`;
